import { Component, Input } from '@angular/core';

import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { SpinnerSize } from 'rev-shared/ui/spinner/Spinner';

import styles from './VbLoadingOverlay.Component.module.less';

/**
 * This is an overlay component which takes 100% of the size of the parent container (which should have style 'position: relative'):
 * - acts as a way to prevent user actions on the elements it is overlayed on
 * - displays a message and a spinner below the message
 * @param {string} loadingMessage - (required) the message to be displayed above the spinner
 * @param {SpinnerSize} spinnerSize - (optional) the size of the spinner, defaults to "LARGE"
 */
@Component({
	standalone: true,
	imports: [
		SpinnerAngularModule
	],
	selector: 'vb-loading-overlay',
	host: {
		'[class]': 'hostClasses'
	},
	template: `
		<vb-loading-spinner
			[size]="spinnerSize"
			[msg]="loadingMessage"
			[customStylesClass]="isAdmin ? '' : styles.customSpinnerStyles">
		</vb-loading-spinner>
	`
})
export class VbLoadingOverlayComponent {
	@Input({ required: true }) public loadingMessage: string;
	@Input() public spinnerSize: SpinnerSize = SpinnerSize.LARGE;
	@Input() public isAdmin: boolean = false;

	public readonly styles = styles;

	public get hostClasses(): string {
		return `${this.styles.root} ${this.isAdmin ? this.styles.whiteBackground : ''}`;
	}
}
